import { loginByUserPwd, regByUserPwd, getInfo, resetPwdByUserPwd } from "@/api/login";
import {
  setToken,
  removeToken,
  getUsername,
  setUsername,
  removeUsername,
} from "@/utils/auth";

const user = {
  state: {
    id: 0, // 用户编号
    name: "",
    avatar: "",
    roles: [],
    permissions: [],
    // 用户信息
    userInfo: null,
  },

  mutations: {
    SET_ID: (state, id) => {
      state.id = id;
    },
    SET_NAME: (state, name) => {
      state.name = name;
    },
    SET_NICKNAME: (state, nickname) => {
      state.nickname = nickname;
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar;
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles;
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions;
    },
    // 设置用户信息
    SET_USER_INFO: (state, userInfo = null) => {
      state.userInfo = userInfo;
    },
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const userName = userInfo.userName.trim();
      const password = userInfo.password;
      return new Promise((resolve, reject) => {
        loginByUserPwd({ userName, password })
          .then((res) => {
            // 设置 token
            setToken(res);
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 注册
    RegisterLogin({ commit }, userInfo) {
      const userName = userInfo.userName.trim();
      return new Promise((resolve, reject) => {
        regByUserPwd({ ...userInfo, userName })
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo()
          .then((res) => {
            commit("SET_USER_INFO", res);
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 退出系统
    LogOut({ commit }) {
      return new Promise((resolve, reject) => {
        try {
          commit("SET_ROLES", []);
          commit("SET_PERMISSIONS", []);
          commit("SET_USER_INFO");
          removeToken();
          resolve();
        } catch (error) {
          reject(error);
        }
      });
    },

    // 重置密码
    ResetPassword({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        resetPwdByUserPwd(userInfo)
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};

export default user;
